import ImageWorker from 'comlink-loader!../webworkers/Image.worker.comlink'

export const {
    formTrayImageWithCounter,
    formTaskBadgeCounter,
} = new ImageWorker()

const APP_IMAGE = '../../../electron/img/24x24.png'

export const getTrayImageWithCounter = async (count) => {
    let test = await formTrayImageWithCounter(APP_IMAGE, count)
    console.log(test)
    return test
}

export const getTaskBadgeCounter = async (count) => {
    let test = await formTaskBadgeCounter(count)
    console.log(test)
    return test
}